import React from 'react'
import PropTypes from 'prop-types'

import { Box, Button } from '@mui/material'
import { EnhancedToolbar } from './toolbar'

import SearchBarre from './searchBarre'
import DisplayMode from '../../../../containers/settings/headOnglet/displayMode'

const HeadOnglet = ({
  title,
  onSearch,
  searchPlaceholder,
  globalID,
  isButtonCreate,
  iconButtonCreate,
  actionButtonCreate,
  isDisplayMode,
  isCardMode,
}) => {
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        paddingRight: isCardMode ? '29px' : '5px',
        width: '100%',
      }}
    >
      <EnhancedToolbar title={title} />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        {isDisplayMode && <DisplayMode />}
        {isButtonCreate && (
          <Button
            sx={{
              height: '33px',
              textTransform: 'capitalize',
              fontSize: '13px',
              fontWeight: 600,
              marginLeft: '9px',
              minWidth: '25px',
              width: '50px',
              marginRight: '8px',
            }}
            variant="contained"
            onClick={actionButtonCreate}
          >
            {iconButtonCreate}
          </Button>
        )}
        <SearchBarre
          globalID={globalID}
          onSearch={onSearch}
          placeholder={searchPlaceholder}
        />
      </Box>
    </Box>
  )
}

HeadOnglet.propTypes = {
  title: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  onSearch: PropTypes.func,
  globalID: PropTypes.string,
  isButtonCreate: PropTypes.bool,
  iconButtonCreate: PropTypes.any,
  actionButtonCreate: PropTypes.func,
  isDisplayMode: PropTypes.bool,
  isCardMode: PropTypes.bool,
}
export default HeadOnglet
